
import Vue from 'b2b-common/vue-config'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'b2b-common/vue-config/axios'
import router from 'b2b-common/vue-config/router'
import 'b2b-common/vue-config/bootstrap.scss'
import '@/assets/scss/bootstrap-custom.scss'
import 'flag-icon-css/css/flag-icon.min.css'
import '@vue-bootstrap-components/vue-bootstrap-autocomplete/dist/VueBootstrapAutocomplete.css'
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import './config/vee-validate'
import './config/gettext'
import routes from './routes'
import App from './app.vue'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/server/' : 'https://b2bstaging.savana.tripsolutions.co.uk/server/'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAf3VgIF6Pca9aZ59SK66eKFjkH_lzBc70'
  }
})

Vue.component('VueBootstrapAutocomplete', VueBootstrapAutocomplete)

router.addRoutes(routes)

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
